var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0615,
    cy: 20.9463,
    r: 19.4787,
    stroke: "white",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3802 12.1289C27.0007 12.1289 26.6367 12.3611 26.3683 12.7745C26.1 13.1878 25.9492 13.7484 25.9492 14.333V27.5576C25.9492 28.1422 26.1 28.7028 26.3683 29.1162C26.6367 29.5295 27.0007 29.7617 27.3802 29.7617C27.7597 29.7617 28.1237 29.5295 28.392 29.1162C28.6604 28.7028 28.8111 28.1422 28.8111 27.5576V14.333C28.8111 13.7484 28.6604 13.1878 28.392 12.7745C28.1237 12.3611 27.7597 12.1289 27.3802 12.1289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7357 12.1289C14.3561 12.1289 13.9922 12.3611 13.7238 12.7745C13.4554 13.1878 13.3047 13.7484 13.3047 14.333V27.5576C13.3047 28.1422 13.4554 28.7028 13.7238 29.1162C13.9922 29.5295 14.3561 29.7617 14.7357 29.7617C15.1152 29.7617 15.4791 29.5295 15.7475 29.1162C16.0159 28.7028 16.1666 28.1422 16.1666 27.5576V14.333C16.1666 13.7484 16.0159 13.1878 15.7475 12.7745C15.4791 12.3611 15.1152 12.1289 14.7357 12.1289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/IconPause.7006f553a9d3ad2cf61ffa959215fa6b.svg";
export { ForwardRef as ReactComponent };